'use es6';

import makeAsyncLoader from './makeAsyncLoader';
const AsyncStockImages = makeAsyncLoader(() => import( /* webpackChunkName: "stock-images" */'../../containers/StockImages').then(module => module.default).catch(err => {
  throw err;
}));
export default AsyncStockImages;